import React from "react";

import { Typography } from "@king-ict/eupisi-ui/components";

interface FetchedDiffValueProps {
  show: boolean;
  children: React.ReactNode;
}

export const FetchedDiffValue = ({ show, children }: FetchedDiffValueProps) => {
  if (!show) return null;

  return (
    <Typography color="primary" component="span">
      {children}
    </Typography>
  );
};
